module.exports = __webpack_public_path__ + "img/featured_banner_01.c0cf6e40.jpg";